interface ContentType {
  plainText?: string;
  htmlElement?: string;
}

export const crmHelp: Record<string, ContentType> = {
  auth: {
    htmlElement: `
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1bfSnI4KOcv5L1ivdvWf0ZrkSojIPOXuM/preview?t=49s" allow="autoplay"></iframe>    
    <br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>`,
  },
  object_type: {
    htmlElement: `    
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1arrj7yuWAWSyoxMoogFxqK4ZRh24Bb4_/preview" allow="autoplay"></iframe>
    <p class="text-center text-bold-600 mb-0">Image Guide</p>
    <img src="https://zint-static.s3.eu-west-2.amazonaws.com/crm-visuals/CRMObjectStep.jpeg" alt="objectType" class="w-100" />    
    <br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>
    `,
  },
  lookup_field: {
    htmlElement: `    
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/15Ooa0NfQ0s4kfrfjWchaCsaDVGVLbmKU/preview" allow="autoplay"></iframe>
    <p class="text-center text-bold-600 mb-0">Image Guide</p>
    <img src="https://zint-static.s3.eu-west-2.amazonaws.com/crm-visuals/LookupStep.jpg" alt="lookup" class="w-100" />
    <br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>`,
  },
  export_mapping: {
    htmlElement: `
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1ZuIClexSxEBT89mWW2v0P4i8NlZfKRPN/preview" allow="autoplay"></iframe>
    <p class="text-center text-bold-600 mb-0">Image Guide</p>
    <img src="https://zint-static.s3.eu-west-2.amazonaws.com/crm-visuals/ExportMappingStep.jpg" alt="export_map" class="w-100" /><br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>
    `,
  },
  superuser_token: {
    htmlElement: `
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1i6LNqCMN5ZE-nQvgQOs_MekBpodPt2lS/preview" allow="autoplay"></iframe>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>`,
  },
  export_permissions: {
    htmlElement: `
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1GI2ORxSXNhFXyOyHtm4H2UoN0petbg0u/preview" allow="autoplay"></iframe>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>`,
  },
  enrichment: {
    htmlElement: `
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1N7BJddTWk-pO05WCFSNLIQAbvC7AKUS0/preview" allow="autoplay"></iframe>
    <p class="text-center text-bold-600 mb-0">Image Guide</p>
    <img src="https://zint-static.s3.eu-west-2.amazonaws.com/crm-visuals/EnrichmentScheduleStep.jpg" alt="enrich" class="w-100" />
    <br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>
    `,
  },
  import_config: {
    htmlElement: `
    <p class="text-center text-bold-600 mb-0">Video Guide</p>
    <iframe class="w-100 min-height-50vh" src="https://drive.google.com/file/d/1lQqC7UAxmZy8o0DkHVLXakgcvd13Euhe/preview" allow="autoplay"></iframe>
    <p class="text-center text-bold-600 mb-0">Image Guide</p>
    <img src="https://zint-static.s3.eu-west-2.amazonaws.com/crm-visuals/ImportMappingStep.jpg" alt="import_map" class="w-100" /><br>
    <a href="https://support.zint.io/" target="_blank">Zendesk Guide</a>
    `,
  },
};
